export default "__VITE_ASSET__ad41bc35__"